import { render, staticRenderFns } from "./AndiamoUtenteViewPage.vue?vue&type=template&id=48c173cb&scoped=true"
import script from "./AndiamoUtenteViewPage.vue?vue&type=script&lang=js"
export * from "./AndiamoUtenteViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c173cb",
  null
  
)

export default component.exports